import React from "react";
import ModalReact from "react-modal";
import closeIcon from "@img/ui/ico-close.svg";
import "./Modal.scss";
import { useWidth } from "@utils/demenstion";

interface ModalProps {
  showModal: boolean;
  children: React.ReactNode;
  handleClose: () => void;
  maxWidth?: number | string;
  className?: string;
}

const Modal = (props: ModalProps) => {
  return (
    <ModalReact
      isOpen={props.showModal}
      onRequestClose={props.handleClose}
      style={{
        content: {
          maxWidth: props.maxWidth
            ? props.maxWidth
            : useWidth() > 768
            ? "800px"
            : "100%",
          maxHeight: 1000,
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          borderRadius: 6,
        },
      }}
      overlayClassName="Overlay"
      className={`Modal ${props.className}`}
      ariaHideApp={false}
    >
      <div className="Modal__wraperClose" onClick={props.handleClose}>
        <img className="Modal__close" src={closeIcon} />
      </div>
      {props.children}
    </ModalReact>
  );
};

export default Modal;
